<template>
  <div v-if="references.length" class="marketplace--references-full-carousel">
    <SloLoader :loading="loading" class="marketplace--references-full-carousel--loader">
      <h2 class="marketplace--references-full-carousel--title">{{ 'You might also like' | t }}</h2>
      <div>

        <div
          v-if="references.length > 5"
          ref="referencesCarouselDesktop"
          class="marketplace--references-full-carousel-desktop--carousel"
        >
          <div class="marketplace--references-full-carousel-desktop--carousel-wrapper">
            <SloCard
              v-for="(reference, referenceKey) in references"
              :key="`reference-${referenceKey}`"
              :url="`/sku/${reference.target.code}`"
            >
              <template v-slot:image>
                <SloProductImage :source="reference.target.images | getProductThumbnail" />
              </template>
              <template v-slot:title>
                {{ reference.target.number }}
              </template>
              <p class="m-0">{{ reference.target.title }}</p>
              <p class="m-0 text-sm">
                {{ 'Code' | t }} {{ reference.target.code }}
                <span v-if="reference.target.type">| {{ reference.target.type }}</span>
              </p>
              <template v-slot:add-to-cart>
                <SloProductMeta :product="{estimatedShipDate: reference?.target?.estimatedShipDate, price: {formattedValue: reference?.target?.price?.formattedValue}}">
                  <span class="text-xl">{{ reference?.target?.uom }}</span>
                </SloProductMeta>
                <SloAddToCart
                  :sku="reference.target.code"
                  :showNumberInput="false"
                  addToCartButtonFill="solid"
                  list-name="cart_upsell"
                />
              </template>
            </SloCard>
          </div>
          <div class="marketplace--references-full-carousel-desktop--carousel-nav">
            <button
              @click="emblaDesktop.scrollPrev()"
              :disabled="emblaDesktopSelectedScrollSnap === 0"
              class="desktop-carousel-prev bg-gray-400 c-white"
            >
              <SloIcon name="ChevronLeft" size="lg" />
            </button>
            <button
              @click="emblaDesktop.scrollNext()"
              :disabled="emblaDesktopSelectedScrollSnap === emblaDesktopScrollSnaps.length - 1"
              class="desktop-carousel-next bg-gray-400 c-white"
            >
              <SloIcon name="ChevronRight" size="lg" />
            </button>
          </div>
          <div class="marketplace--references-full-carousel-desktop--carousel-dots">
            <button
              v-for="(snap, index) in emblaDesktopScrollSnaps"
              :key="index" @click="emblaDesktop.scrollTo(index)"
              :class="index === emblaDesktopSelectedScrollSnap ? 'active' : ''"
              class="marketplace--references-full-carousel-desktop--carousel-dot"
            ></button>
          </div>
        </div>

        <div v-else class="marketplace--references-full-carousel--products">
          <SloCard
            v-for="(reference, referenceKey) in references"
            :key="`reference-${referenceKey}`"
            :url="`/sku/${reference.target.code}`"
          >
            <template v-slot:image>
              <SloProductImage :source="reference.target.images | getProductThumbnail" />
            </template>
            <template v-slot:title>
              {{ reference.target.number }}
            </template>
            <p class="m-0">{{ reference.target.title }}</p>
            <p class="m-0 text-sm">
              {{ 'Code' | t }} {{ reference.target.code }}
              <span v-if="reference.target.type">| {{ reference.target.type }}</span>
            </p>
            <template v-slot:add-to-cart>
              <SloProductMeta :product="{estimatedShipDate: reference?.target?.estimatedShipDate, price: {formattedValue: reference?.target?.price?.formattedValue}}">
                <span class="text-xl">{{ reference?.target?.uom }}</span>
              </SloProductMeta>
              <SloAddToCart
                :sku="reference.target.code"
                :showNumberInput="false"
                addToCartButtonFill="solid"
                list-name="cart_upsell"
              />
            </template>
          </SloCard>
        </div>
      </div>

      <!-- Mobile -->
      <div>
        <div ref="referencesCarousel" class="marketplace--references-full-carousel--carousel">
          <div class="marketplace--references-full-carousel-wrapper">
            <SloCard
              v-for="(reference, referenceKey) in references"
              :key="`reference-${referenceKey}`"
            >
              <template v-slot:image>
                <SloProductImage :source="reference?.target?.images | getProductThumbnail" />
              </template>
              <template v-slot:title>
                {{ reference?.target?.number }}
              </template>
              <p class="m-0">{{ reference?.target?.title }}</p>
              <p class="m-0 text-sm">
                {{ 'Code' | t }} {{ reference?.target?.code }}
                <span v-if="reference?.target?.type">| {{ reference?.target?.type }}</span>
              </p>
              <template v-slot:add-to-cart>
                <SloProductMeta :product="{estimatedShipDate: reference?.target?.estimatedShipDate, price: {formattedValue: reference?.target?.price?.formattedValue}}">
                  <span class="text-xl">{{ reference?.target?.uom }}</span>
                </SloProductMeta>
                <SloAddToCart
                  :sku="reference?.target?.code"
                  :showNumberInput="false"
                  addToCartButtonFill="solid"
                  list-name="cart_upsell"
                />
              </template>
            </SloCard>
          </div>
          <div class="marketplace--references-full-carousel--carousel-nav">
            <button
              @click="embla.scrollPrev()"
              :disabled="emblaSelectedScrollSnap === 0"
              class="mobile-carousel-prev bg-gray-400 c-white"
            >
              <SloIcon name="ChevronLeft" size="lg" />
            </button>
            <button
              @click="embla.scrollNext()"
              :disabled="emblaSelectedScrollSnap === emblaScrollSnaps.length - 1"
              class="mobile-carousel-next bg-gray-400 c-white"
            >
              <SloIcon name="ChevronRight" size="lg" />
            </button>
          </div>
          <div class="marketplace--references-full-carousel--carousel-dots">
            <button
              v-for="(snap, index) in emblaScrollSnaps"
              :key="index" @click="embla.scrollTo(index)"
              :class="index === emblaSelectedScrollSnap ? 'active' : ''"
              class="marketplace--references-full-carousel--carousel-dot"
            ></button>
          </div>
        </div>
      </div>
    </SloLoader>
  </div>
</template>

<script>
import EmblaCarousel from 'embla-carousel';
import t from '../../main/i18n';
import {getProductThumbnail} from '../../main/utils';
import SloLoader from '../../../lib/components/SloLoader.vue';
import SloCard from '../../../lib/components/SloCard.vue';
import SloProductImage from '../../../lib/components/SloProductImage.vue';
import SloAddToCart from '../../../lib/components/SloAddToCart.vue';
import SloProductMeta from '../../../lib/components/SloProductMeta.vue';
import SloIcon from '../../../lib/components/SloIcon.vue';

export default {
  name: 'ReferencesFullCarousel',
  components: {
    SloLoader,
    SloCard,
    SloProductImage,
    SloAddToCart,
    SloProductMeta,
    SloIcon
  },
  filters: {
    t,
    getProductThumbnail
  },
  data() {
    return {
      embla: null,
      emblaDesktop: null,
      emblaDesktopScrollSnaps: [],
      emblaDesktopSelectedScrollSnap: null,
      emblaScrollSnaps: [],
      emblaSelectedScrollSnap: null
    };
  },
  props: {
    loading: {type: Boolean, required: true},
    references: {type: Array, required: true}
  },
  mounted() {
    setTimeout(() => this.initReferencesCarouselDesktop(), 500);
    setTimeout(() => this.initReferencesCarousel(), 500);
  },
  methods: {
    initReferencesCarouselDesktop() {
      if (this.$refs.referencesCarouselDesktop) {
        this.emblaDesktop = EmblaCarousel(
          this.$refs.referencesCarouselDesktop,
          {loop: false, draggable: true, containScroll: 'trimSnaps', align: 'start'}
        );
        this.emblaDesktop.on('select', this.onEmblaDesktopDotSelect);
        this.emblaDesktopScrollSnaps = this.emblaDesktop.scrollSnapList();
        this.onEmblaDesktopDotSelect();
      }
    },
    initReferencesCarousel() {
      if (this.$refs.referencesCarousel) {
        this.embla = EmblaCarousel(
          this.$refs.referencesCarousel,
          {loop: false, draggable: true, containScroll: 'trimSnaps'}
        );
        this.embla.on('select', this.onEmblaDotSelect);
        this.emblaScrollSnaps = this.embla.scrollSnapList();
        this.onEmblaDotSelect();
      }
    },
    onEmblaDesktopDotSelect() {
      this.emblaDesktopSelectedScrollSnap = this.emblaDesktop.selectedScrollSnap();
    },
    onEmblaDotSelect() {
      this.emblaSelectedScrollSnap = this.embla.selectedScrollSnap();
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../scss/variables';
@import '../../../scss/system';

.marketplace--references-full-carousel {
  margin-block-start: 3.2rem;
  margin-inline: -1.5rem;
  padding-inline: 1.5rem;
  overflow: hidden;

  @media (min-width: $screen-md) {
    grid-column: 1 / -1;
    margin-block-start: 0;
    padding-block-end: 2.4rem;
  }

  &--title {
    font-size: 2.2rem;
    font-weight: 500;
    margin: 0;
  }

  &--products {
    display: none;

    @media (min-width: $screen-md) {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 3.2rem;
      margin-block-start: 2.4rem;
    }
  }

  &-desktop {
    &--carousel {
      position: relative;
      display: none;

      @media (min-width: $screen-md) {
        display: block;
        margin-block-start: 2.4rem;
        margin-inline: -1.6rem;
        padding-inline: 1.6rem;
        overflow: hidden;
      }
    }

    &--carousel-wrapper {
      display: flex;
      column-gap: 1.8rem;
      padding-block-end: 2.4rem;

      @media (min-width: $screen-md) {
        .slo-card {
          flex: 0 0 31.3333%;
        }
      }

      @media (min-width: $screen-lg) {
        .slo-card {
          flex: 0 0 18.9556%;
          max-width: 336px;
        }
      }
    }

    &--carousel-dots {
      display: flex;
      align-items: center;
      justify-content: center;
      column-gap: 0.8rem;
      margin-block-start: 3.2rem;
    }

    &--carousel-dot {
      width: 8px;
      height: 8px;
      padding: 0;
      border-radius: 9999px;
      background-color: $color-gray-400;
      cursor: pointer;

      &.active {
        background-color: $color-blue-400;
      }
    }
  }

  &--carousel {
    position: relative;
    margin-block-start: 2.4rem;

    @media (min-width: $screen-md) {
      display: none;
    }
  }

  &-wrapper {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: 100%;
    column-gap: 2.4rem;

    @media (min-width: $screen-sm) {
      grid-auto-columns: 50%;
    }

    .slo-card {
      max-width: 380px;
    }
  }

  &--carousel-dots {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 0.8rem;
    margin-block-start: 3.2rem;

    @media (min-width: 768px) {
      display: none;
    }
  }

  &--carousel-dot {
    width: 8px;
    height: 8px;
    padding: 0;
    border-radius: 9999px;
    background-color: $color-gray-400;
    cursor: pointer;

    &.active {
      background-color: $color-blue-400;
    }
  }

  @media print {
    display: none;
  }
}

.marketplace--references-full-carousel-desktop--carousel-nav,
.marketplace--references-full-carousel--carousel-nav {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  button {
    width: 4.8rem;
    height: 4.8rem;
    padding: 0;
    border-radius: 9999px;

    &:hover {
      color: $color-white;
    }

    &.desktop-carousel-prev,
    &.mobile-carousel-prev {
      position: relative;
      left: -8px;
    }

    &.desktop-carousel-next {
      position: relative;
      right: 24px;
    }

    &.mobile-carousel-next {
      position: relative;
      right: -8px;
    }
  }
}

.marketplace--references-full-carousel--carousel-nav {
  top: 45%;
}
</style>
